import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "192.52277007900003 0 170.93186706300003 159.71796863894966",
	"data-name": "Layer 1",
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	style: { maxHeight: 500 },
	width: 170.93186706300003,
	height: 159.71796863894966,
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".cls-1{fill:#fff;}.cls-2{fill:#486ee5;}" }) }), /* @__PURE__ */ _jsx("path", {
		transform: "translate(-222.511 -373.278)",
		d: "M499.659,373.279a84.971,84.971,0,0,0-82.537,62.768,32.876,32.876,0,0,0-.71,14.368c1.121,6.228,4.937,10.18,12.634,6.213a18.766,18.766,0,0,0,5.027-3.892c16.29-17.336,48.59-20.412,63.548-2.734,11.842,3.862,37.075,12.877,24.478,30.633-3.407-8.09-6.659-8.064-13.5-7.792a33.792,33.792,0,0,0-22.132,9.219c-14.308,13.769-8.289,32.047,9.786,42.941,22,13.259,50.375,8.155,67.17-11.277a84.938,84.938,0,0,0-63.766-140.447Z",
		className: "cls-2"
	})]
});
export default SvgIcon;
